module.exports = __webpack_public_path__ + "img/sscopelogo.36957046.svg";